export { default as RiskLosingDay } from "./RiskLosingDay.component";
